import App from 'container';
import React, { Component, PropTypes } from 'react';
import { IndexRedirect, IndexRoute, Route, Router } from 'react-router';
import NotFound from 'views/404';
import AdvisoryTool from 'views/advisory-tool/container';
import AdvisoryToolDetail from 'views/advisory-tool/detail/container';
import AdvisoryToolResult from 'views/advisory-tool/result/container';
import AdvisoryToolStart from 'views/advisory-tool/start/container';
import Maintenance from 'views/maintenance';
import QuoteView from 'views/quote-view/container';
import SystemView from 'views/system-view/container';
import Systems from 'views/systems/container';
import SystemsDetail from 'views/systems/detail/container';
import SystemsDetailDesign from 'views/systems/detail/design/container';
import SystemsDetailQuote from 'views/systems/detail/quote/container';
import SystemsDetailShare from 'views/systems/detail/share/container';
import SystemsOverview from 'views/systems/overview/container';

class AppRouter extends Component {
  render() {
    const { history, onUpdateRouter } = this.props;

    return (
      <Router history={history} onUpdate={onUpdateRouter}>
        <Route path="/" component={App}>
          <IndexRedirect to="advisory-tool" />

          {/* Advisory Tool */}
          <Route path="advisory-tool" component={AdvisoryTool}>
            <IndexRoute component={AdvisoryToolStart} />
            <Route path="result" component={AdvisoryToolResult} />
            <Route path=":questionId" component={AdvisoryToolDetail} />
          </Route>

          {/* Systems */}
          <Route path="systems" component={Systems}>
            <IndexRoute component={SystemsOverview} />
            <Route path=":projectId" component={SystemsDetail}>
              <IndexRedirect to="design" />
              <Route path="design" component={SystemsDetailDesign} />
              <Route path="quote" component={SystemsDetailQuote} />
              <Route path="share" component={SystemsDetailShare} />
            </Route>
          </Route>

          {/* Maintenance */}
          <Route path="maintenance" component={Maintenance} />

          {/* 404 */}
          <Route path="404" component={NotFound} />

          {/* Separate route for server side system sketch rendering */}
          <Route path="system-view" component={SystemView} />

          {/* Separate route for server quote rendering */}
          <Route path="quote-view/:projectId" component={QuoteView} />

          {/* Wildcard */}
          <Route path="*" component={NotFound} />
        </Route>
      </Router>
    );
  }
}

AppRouter.propTypes = {
  history: PropTypes.object,
  onUpdateRouter: PropTypes.func,
};

export default AppRouter;



// WEBPACK FOOTER //
// ./js/app-router.jsx